import { commonClientResx } from "../../../resxDist/commonClientResx";
import { createButton } from "../Button";
import { ButtonColorSchemes } from "../Enums";

/** 'Delete' text by default */
export const ButtonNegative = createButton("ButtonNegative", {
    colorScheme: ButtonColorSchemes.Danger,
    text: commonClientResx.Delete,
});
